import React from 'react'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { InputField } from '@/components/molecules/input-field'
import { useCashChangerSetting } from '@/hooks/self-checkin-device-settings/use-cash-changer-setting'
import { modalDeviceFormStyle, modalDeviceInputStyle } from './modal-form-styles'
import { DeviceSettingsModalFrame, DeviceSettingsModalNavigationProps } from './modal-frame'

type Props = DeviceSettingsModalNavigationProps & {
  hotelId: string
}

export const CashChangerDeviceSettingsPanel: React.FC<Props> = props => {
  const { t } = useTranslation()
  const { control, isDirty, isLoading, canTestConnection, testConnection, save, cancel } = useCashChangerSetting(props.hotelId)

  return (
    <DeviceSettingsModalFrame
      {...props}
      isLoading={isLoading}
      isDirty={isDirty}
      onCancel={cancel}
      onSave={save}
      connectionTest={{ onTest: testConnection, isDisabled: !canTestConnection }}
    >
      <div css={modalDeviceFormStyle}>
        <div className="input-container">
          <div className="input-label">{t('SB-H50 serial number')}</div>
          <Controller
            control={control}
            name="cashChangerSerialNumber"
            render={({ field: { onChange, value } }) => (
              <InputField
                value={value}
                marginBottom={0}
                customInputStyle={modalDeviceInputStyle}
                handleChangeData={onChange}
                placeholder="XXXX000001"
              />
            )}
          />
        </div>
      </div>
    </DeviceSettingsModalFrame>
  )
}
